import React from 'react';

const viBaselineVisual = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      {/* eslint-disable-next-line max-len */}
      <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M14.5 10C15.4319 10 15.8978 10 16.2654 9.84776C16.7554 9.64477 17.1448 9.25542 17.3478 8.76537C17.5 8.39782 17.5 7.93188 17.5 7C17.5 6.06812 17.5 5.60218 17.3478 5.23463C17.1448 4.74458 16.7554 4.35523 16.2654 4.15224C15.8978 4 15.4319 4 14.5 4L6.5 4C5.56812 4 5.10218 4 4.73463 4.15224C4.24458 4.35523 3.85523 4.74458 3.65224 5.23463C3.5 5.60218 3.5 6.06812 3.5 7C3.5 7.93188 3.5 8.39782 3.65224 8.76537C3.85523 9.25542 4.24458 9.64477 4.73463 9.84776C5.10218 10 5.56812 10 6.5 10L14.5 10Z" />
      {/* eslint-disable-next-line max-len */}
      <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M18.5 20C19.4319 20 19.8978 20 20.2654 19.8478C20.7554 19.6448 21.1448 19.2554 21.3478 18.7654C21.5 18.3978 21.5 17.9319 21.5 17C21.5 16.0681 21.5 15.6022 21.3478 15.2346C21.1448 14.7446 20.7554 14.3552 20.2654 14.1522C19.8978 14 19.4319 14 18.5 14H6.5C5.56812 14 5.10218 14 4.73463 14.1522C4.24458 14.3552 3.85523 14.7446 3.65224 15.2346C3.5 15.6022 3.5 16.0681 3.5 17C3.5 17.9319 3.5 18.3978 3.65224 18.7654C3.85523 19.2554 4.24458 19.6448 4.73463 19.8478C5.10218 20 5.56812 20 6.5 20L18.5 20Z" />
    </g>
  </svg>
);

export default viBaselineVisual;
